import React, {useEffect, useState} from "react"
import GenericModal from "@irati/ui/src/GenericModal"
import FormattedMessage from "@irati/utils/lang"
import {H3} from "@irati/ui/src/Typography"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {PointsRequest, PointsRequestStatus} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import UpdateStatusRequestPointsForm from "./UpdateStatusForm"
import UpdateRequestPointsSuccess from "./UpdateStatusSuccess"

interface Props {
  show: boolean
  status: PointsRequestStatus
  pointsRequest: PointsRequest
  onHide: () => void
}

enum ModalTypes {
  FORM,
  SUCCESS
}
const UpdateStatusRequestPointsModal = (props: Props) => {
  const {show, onHide, status, pointsRequest: defaultPointsRequest} = props
  const [pointsRequest, setPointsRequest] = useState(defaultPointsRequest)
  const [modalType, setModalType] = useState(ModalTypes.FORM)
  useEffect(() => {
    if (pointsRequest) return
    setPointsRequest(defaultPointsRequest)
  }, [defaultPointsRequest])
  const closeModal = () => {
    setModalType(ModalTypes.FORM)
    onHide()
  }
  const onDone = (newPointsRequest: PointsRequest) => {
    setPointsRequest(newPointsRequest)
    setModalType(ModalTypes.SUCCESS)
  }
  return (
    <GenericModal show={show} onHide={closeModal} customWidth={600} hideActions>
      <H3 marginBottom={3}>
        {status === PointsRequestStatus.StatusApproved && modalType === ModalTypes.FORM && (
          <FormattedMessage id="wallet.reward.pointsRequest.modal.updateStatus.approve.title" />
        )}
        {status === PointsRequestStatus.StatusDeclined && modalType === ModalTypes.FORM && (
          <FormattedMessage id="wallet.reward.pointsRequest.modal.updateStatus.decline.title" />
        )}
        {ModalTypes.SUCCESS === modalType && (
          <Flex gap={1} alignItems="center">
            <Icon icon={IconTypes.circleCheckFill} />
            {status === PointsRequestStatus.StatusApproved && (
              <FormattedMessage id="wallet.reward.pointsRequest.modal.updateStatus.approveConfirmed.title" />
            )}
            {status === PointsRequestStatus.StatusDeclined && (
              <FormattedMessage id="wallet.reward.pointsRequest.modal.updateStatus.declineConfirmed.title" />
            )}
            {status === PointsRequestStatus.StatusCancelled && (
              <FormattedMessage id="wallet.reward.pointsRequest.modal.updateStatus.cancelledConfirmed.title" />
            )}
          </Flex>
        )}
      </H3>
      {ModalTypes.FORM === modalType && (
        <UpdateStatusRequestPointsForm onCancel={closeModal} onDone={onDone} status={status} uuid={pointsRequest?.uuid} />
      )}
      {ModalTypes.SUCCESS === modalType && pointsRequest && (
        <UpdateRequestPointsSuccess onHide={closeModal} pointsRequest={pointsRequest} />
      )}
    </GenericModal>
  )
}
export default UpdateStatusRequestPointsModal
